export default __webpack_public_path__ + "static/media/mq-new-4.6a0121f1.jpg";